import { render } from "./StorePage.vue?vue&type=template&id=00d89f13"
import script from "./StorePage.vue?vue&type=script&lang=js"
export * from "./StorePage.vue?vue&type=script&lang=js"

import "./StorePage.vue?vue&type=style&index=0&id=00d89f13&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__